import { Building2Icon, HardDriveIcon, Share2Icon, Trash2Icon, UsersRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { CommandItem } from '@/shared/registry/types';

const matches = (query: string, ...texts: string[]) => {
  const q = query.trim().toLocaleLowerCase();
  return !!q && texts.some((text) => text.toLocaleLowerCase().includes(q));
};

/** ⌘K: the disk's places (My drive, Shared with me, Company drive, group drives, Trash) when the query names them. */
export function useDiskCommands(query: string): { items: CommandItem[] } {
  const { t } = useTranslation('disk');
  const keywords = t('palette.keywords');
  const all: CommandItem[] = [
    { id: 'disk:my', label: t('palette.my'), icon: HardDriveIcon, keywords: [keywords], to: '/disk' },
    {
      id: 'disk:shared',
      label: t('palette.shared'),
      icon: Share2Icon,
      keywords: [keywords],
      to: '/disk/shared',
    },
    {
      id: 'disk:company',
      label: t('palette.company'),
      icon: Building2Icon,
      keywords: [keywords],
      to: '/disk/company',
    },
    {
      id: 'disk:groups',
      label: t('palette.groups'),
      icon: UsersRoundIcon,
      keywords: [keywords],
      to: '/disk/groups',
    },
    {
      id: 'disk:trash',
      label: t('palette.trash'),
      icon: Trash2Icon,
      keywords: [keywords],
      to: '/disk/trash',
    },
  ];
  return { items: all.filter((item) => matches(query, item.label, ...(item.keywords ?? []))) };
}
